import React from 'react';
import Switch from '../../../../../scripts/components/common/inputs/customs/switch';
import SelectInput from '../../../../../scripts/components/common/inputs/select-input';
import EmbedCode from '../../../../../scripts/components/common/embed-code';
import { CUSTOM_LOCATION, PITC_LOCATIONS, SIDERAIL } from '../constants/products-constants';

type Props = {
  isEnabled: boolean;
  setIsEnabled: (boolean) => void;
  isDoubleDeckerEnabled: boolean;
  setIsDoubleDeckerEnabled: (boolean) => void;
  location: string;
  setLocation: (string) => void;
};

const PitC: React.FC<Props> = ({ isEnabled, setIsEnabled, isDoubleDeckerEnabled, setIsDoubleDeckerEnabled, location, setLocation }) => {
  return (
    <div className="conversationHeaders">
      <div className="main-section">
        <div className="embed-section">
          <Switch
            title="Popular in the Community"
            description='Enable the "Popular in the Community" product'
            value={isEnabled}
            onChange={() => setIsEnabled(!isEnabled)}
          />

          <SelectInput
            description="Choose Location"
            onChange={option => setLocation(option.value)}
            options={PITC_LOCATIONS}
            value={PITC_LOCATIONS.find(option => option.value === location)}
          />

          {(location === SIDERAIL || location === CUSTOM_LOCATION) && (
            <div>
              <EmbedCode
                type="pitc"
                isSidebar={location === SIDERAIL}
                title="Embed Code"
                description="Embed this code where you'd like PitC to load on the page."
                key={location}
              />
              <div className="product-note">
                <b>Note:</b> If you choose “Custom location” or “Siderail” and the publisher doesn’t
                put a div on the page the the unit will appear above the conversation by default.
              </div>
            </div>
          )}

          <Switch
            title="More conversations"
            description="Enable the “More Conversations for You” product"
            value={isDoubleDeckerEnabled}
            onChange={() => setIsDoubleDeckerEnabled(!isDoubleDeckerEnabled)}
          />
        </div>
      </div>
    </div>
  );
};

export default PitC;
